
/* tslint:disable */
/* eslint:disable */
// prettier-ignore
// ReSharper disable RedundantEmptyConstructor
// ReSharper disable InconsistentNaming
/* 
   This file is automatically generated, all manual changes to this file will be lost.

   Generated with command: dotnet entitygen generate -i INPUT_PATH -o OUTPUT_PATH -n Helsenorge.Representasjon.InternalApi.Entities -l TypeScript
 */
// ------ Enum members ------
export enum RepresentasjonsforholdForeldreansvarSubType
{
    DagligOmsorg = "DagligOmsorg"
}
export enum RepresentasjonsforholdFullmaktSubType
{
    Ordinaer = "Ordinaer",
    Tildelt = "Tildelt"
}
export enum RepresentasjonsforholdType
{
    InnloggetBruker = "InnloggetBruker",
    Fullmakt = "Fullmakt",
    Foreldreansvar = "Foreldreansvar"
}
// ReSharper restore RedundantEmptyConstructor
// ReSharper restore InconsistentNaming
/* tslint:enable */